(ns story-builder.showcase.core
  (:require
   [cljs.reader]
   [goog.dom :as gdom]
   [goog.object :as gobj]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [reagent.dom.client :as rdom]
   [story-builder.define :as define]
   [story-builder.showcase.view :as showcase.view]
   [story-builder.util.core :as util]))

(rf/reg-event-db
 ::initialize-db
 (fn [_ [_ {:keys [layer-type
                   locale
                   feature
                   industry
                   pagination
                   search-query
                   showcase
                   website-alias
                   website-id]}]]
   {:filters       {:applied {:feature    feature
                              :industry   industry
                              :locale     locale
                              :layer-type layer-type}
                    :pending {:feature    feature
                              :industry   industry
                              :locale     locale
                              :layer-type layer-type}}
    :pagination    pagination
    :search-query  search-query
    :showcase      showcase
    :website-alias website-alias
    :website-id    website-id}))

(defn render [el config]
  (let [render-fn (if (.hasChildNodes (js/document.getElementById "showcase"))
                    #(rdom/hydrate-root el (r/as-element [showcase.view/showcase config]))
                    #(rdom/render (rdom/create-root el) (r/as-element [showcase.view/showcase config])))
        init      render-fn]
    (if (gdom/getElement "NWSStory-style")
      (init)
      (let [css-url (if define/env-dev?
                      (str (:resources define/URLs) "/css/NWSStory.css")
                      (str (:resources define/URLs) "/css/stories/NWSStory.min.css"))
            css     (gdom/createDom goog.dom.TagName.LINK
                                    #js {:rel  "stylesheet"
                                         :id   "NWSStory-style"
                                         :as   "style"
                                         :href css-url})]
        (set! (.-onload css) init)
        (gdom/appendChild js/document.head css)))))

(when define/frontend?
  (gobj/set js/window "__nws"
            #js {"render"
                 (fn [el config-string]
                   (let [config (try
                                  (util/read-transit config-string)
                                  (catch :default e
                                    (prn e)
                                    (try
                                      (cljs.reader/read-string config-string)
                                      (catch :default e (prn e)))))]
                     (rf/dispatch-sync [::initialize-db config])
                     (render el config)))}))